import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['assumptionsOpen'];

  declare assumptionsOpenTarget: HTMLInputElement;

  openAssumptions(): void {
    this.assumptionsOpenTarget.value = 'true';
    this.element.classList.add('active');
  }
}
